import React, { useState } from 'react';
import { Typography, TextField, Button, Box } from '@mui/material';
import { default as Grid } from '@mui/material/Grid2';

export default function ChangePassword() {
    const [input, setInput] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Cambio de contraseña enviado:', input);
        setMessage('Contraseña actualizada exitosamente.');
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Cambiar contraseña
            </Typography>
            {message && (
                <Typography color="error" gutterBottom>
                    {message}
                </Typography>
            )}
            <form onSubmit={handleSubmit} name="change-password" method="post">
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            variant="standard"
                            fullWidth
                            label="Contraseña actual"
                            name="oldPassword"
                            type="password"
                            value={input.oldPassword}
                            onChange={handleChange}
                            placeholder="contraseña actual"
                            helperText="Por favor, ingrese su contraseña actual."
                            inputProps={{
                                autoComplete: 'current-password',
                                'aria-required': 'true',
                            }}
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            variant="standard"
                            fullWidth
                            label="Nueva contraseña"
                            name="newPassword"
                            type="password"
                            value={input.newPassword}
                            onChange={handleChange}
                            placeholder="nueva contraseña"
                            helperText="Por favor, ingrese su nueva contraseña."
                            inputProps={{
                                autoComplete: 'new-password',
                                'aria-required': 'true',
                            }}
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            variant="standard"
                            fullWidth
                            label="Confirmar contraseña"
                            name="confirmPassword"
                            type="password"
                            value={input.confirmPassword}
                            onChange={handleChange}
                            placeholder="confirmar contraseña"
                            helperText="Por favor, confirme su nueva contraseña."
                            inputProps={{
                                autoComplete: 'new-password',
                                'aria-required': 'true',
                            }}
                            required
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            Actualizar contraseña
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}
